import type { ReactElement } from 'react';
import { TooltipTrigger } from 'react-aria-components';

import { ExpandStrokeIcon, IconButton, Tooltip } from '@/libs/serenity-ui';
import { usePayoutExpandToolbar } from '@/routes/_main/_list/metrics/-components/payout-table.component';

export function ToggleExpandableRowsButton (): ReactElement {
  const { hasExpandedAny, toggleAll } = usePayoutExpandToolbar();

  return (
    <TooltipTrigger>
      <IconButton
        aria-label={hasExpandedAny ? 'Collapse all' : 'Expand all'}
        size={40}
        variant="ghost"
        onPress={toggleAll}>
        <ExpandStrokeIcon />
      </IconButton>
      <Tooltip>{hasExpandedAny ? 'Collapse all' : 'Expand all'}</Tooltip>
    </TooltipTrigger>
  );
}
